// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sn-9";
export var arrowButtonContainer = "_sn-5";
export var arrowButtonIcon = "_sn-6";
export var carouselArrowButton = "_sn-2";
export var carouselElementContainer = "_sn-1";
export var currentSlide = "_sn-8";
export var left = "_sn-3";
export var otherSlide = "_sn-a";
export var productCarouselContainer = "_sn-0";
export var right = "_sn-4";
export var sliderOverflow = "_sn-7";